import Vue from 'vue'
import Router from 'vue-router'

import IndexView from '@/components/index/'

// session related view
import LoginView from '@/components/session/login.view'
import WxLoginView from '@/components/session/wxlogin.view'
import WxBindView from '@/components/session/wxbind.view'
import RegisterView from '@/components/session/register.view'
import CellphoneRegisterView from '@/components/session/cellphone_register.view'
import PasswordView from '@/components/session/password.view'
import ResetPasswordView from '@/components/session/reset_password.view'
import ApiApplicationView from '@/components/session/api_application.view'

// project related view
import ProjectView from '@/components/project/'
import ProjectShowView from '@/components/project/show/'
import ProjectUploadView from '@/components/project/upload/'
import ProjectStatsView from '@/components/project/stats/'
import ProjectStatsSummaryView from '@/components/project/stats/summary.view'
import ProjectStatsFormView from '@/components/project/stats/form.view'

// profile related view
import ProfileView from '@/components/profile/'
import ProfileAccountView from '@/components/profile/account/'
import ProfileIncomeView from '@/components/profile/income/'
import ProfileDevelopmentView from '@/components/profile/development/'

import MembersView from '@/components/members/'

// 一些独立的页面
import PriceView from '@/components/price/'
import OrderView from '@/components/order/'
import TeacherVerificationView from '@/components/teacher/teacher_verification'

// dashboard view
import DashboardView from '@/components/dashboard/'

// faq view
import FaqPermanentsView from '@/components/faq/permanents'

// import global event-driven
import crosstab from 'crosstab'
import bus from '@/utils/bus'

// weixin-js-sdk
import { lazyload } from '@/assets/scripts/lazy-load-module'
import { weixinConfig } from '@/api/miscellaneous'

Vue.use(Router)

const routes = [{
  path: '/categories/:id*',
  alias: '/projects',
  name: 'category',
  component: IndexView
}, {
  path: '/projects/:id*',
  component: ProjectView,
  children: [{
    path: 'upload',
    alias: '/projects/new',
    name: 'project_upload',
    component: ProjectUploadView
  }, {
    path: 'stats',
    component: ProjectStatsView,
    children: [{
      path: 'form',
      component: ProjectStatsFormView
    }, {
      path: '',
      component: ProjectStatsSummaryView
    }]
  }, {
    path: '',
    name: 'project',
    component: ProjectShowView
  }]
}, {
  path: '/profile',
  component: ProfileView,
  children: [{
    path: 'income',
    component: ProfileIncomeView
  }, {
    path: 'development',
    component: ProfileDevelopmentView
  }, {
    path: '',
    name: 'profile',
    alias: 'account',
    component: ProfileAccountView
  }]
}, {
  path: '/members',
  name: 'members',
  component: MembersView
}, {
  path: '/dashboard',
  name: 'dashboard',
  component: DashboardView
}, {
  path: '/order',
  name: 'order',
  component: OrderView
}, {
  path: '/teacher',
  name: 'teacher',
  component: TeacherVerificationView
}, {
  path: '/price',
  name: 'price',
  component: PriceView,
  meta: { noSession: 'both', fullscreen: true }
}, {
  path: '/faq/permanent',
  component: FaqPermanentsView,
  meta: { noSession: 'both' }
}, {
  path: '/apply/company',
  component: ApiApplicationView,
  meta: { noSession: 'both' }
}, {
  path: '/login',
  name: 'login',
  component: LoginView,
  meta: { noSession: true }
}, {
  path: '/wxlogin',
  name: 'wxlogin',
  component: WxLoginView,
  meta: { noSession: true }
}, {
  path: '/wxbind',
  name: 'wxbind',
  component: WxBindView,
  meta: { noSession: true }
}, {
  path: '/register',
  name: 'm_register',
  component: CellphoneRegisterView,
  meta: { noSession: true }
}, {
  path: '/register/email',
  name: 'e_register',
  component: RegisterView,
  meta: { noSession: true }
}, {
  path: '/password',
  name: 'password',
  component: PasswordView,
  meta: { noSession: true }
}, {
  path: '/password/reset',
  component: ResetPasswordView,
  meta: { noSession: true }
}, {
  path: '/error',
  name: 'error',
  component: {
    render(h) {
      return h('div', '异常页面，我们正在积极修复中...')
    }
  }
}, {
  path: '*',
  redirect: '/projects'
}]

let vueStore = null
let returnTo = null

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return {
      x: 0,
      y: 0
    }
  }
}
//
const beforeEach = (to, from, next) => {
  if (to.name === 'error') {
    next()
    return
  }

  if (to.path === '/login' && to.query.returnTo) {
    returnTo = to.query.returnTo
  }

  if (to.query.closeOnPQuota) {
    // register close window on get Permanent quotas
    bus.$on('GetPermanentsQuota', () => {
      // let other tab to refresh
      crosstab.broadcast('refresh')
      window.setTimeout(() => {
        window.close()
      }, 500)
    })
  }

  if (vueStore) {
    // 用来获得当前session状态
    let noSessionRequired = to.meta.noSession
    // undefined -- session required, true -- no session required and need redirect if there is session, 'both' -- pass validation

    // get session info
    let redirectWithSession = () => {
      if (to.query.code && /^\/register/.test(to.path)) {
        window.alert('抱歉，本活动仅限新用户参与')
        next('/')
        return
      }

      if (returnTo) {
        let _destination = { path: returnTo }
        returnTo = null
        next(_destination)
        return
      }

      if (noSessionRequired === true) {
        next('/')
        return
      }

      next()
    }

    let redirectWithNoSession = () => {
      if (noSessionRequired === undefined) {
        next('/login')
      } else {
        next()
      }
    }

    let session = vueStore.getters['user/session']
    if (session) {
      redirectWithSession()
    } else if (session === false) {
      redirectWithNoSession()
    } else {
      vueStore.dispatch('user/get').then(res => {
        res === false ? redirectWithNoSession() : redirectWithSession()
      })
    }
    return
  }
  next('error')
}

const inWechat = /micromessenger/i.test(window.navigator.userAgent)
const afterEach = (route) => {
  // weixin need re-register jsapi if we want share in SPA
  if (inWechat) {
    lazyload('weixin').then(_ => {
      let wx = window.wx

      weixinConfig().then(res => {
        let config = res.data.wx_config
        wx.ready(() => {
          let shareObj = {
            title: 'PP匠',
            desc: '上传PPT，一键生成H5',
            link: 'https://ppj.io',
            imgUrl: 'https://ppj.io/static/images/share.png'
          }

          wx.onMenuShareTimeline(shareObj)
          wx.onMenuShareAppMessage(shareObj)
          wx.onMenuShareQQ(shareObj)
          wx.onMenuShareWeibo(shareObj)
          wx.onMenuShareQZone(shareObj)
        })

        wx.config(config)
      })
    })
  }
}

const supportsPushState = (() => {
  const ua = window.navigator.userAgent

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})()

// export default [].concat(main)
let router = null
export function createRouter(store) {
  router = new Router({
    mode: 'history',
    scrollBehavior,
    base: supportsPushState ? '' : 'v2',
    routes
  })
  // 注册全局导航钩子
  router.beforeEach(beforeEach)
  router.afterEach(afterEach)

  if (store) {
    vueStore = store
  }
  return router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js